import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import { useQuery } from 'react-query';

import {
  getTaskStepWizard,
  GetTaskStepWizardParams,
  TaskStepHomeResponse,
} from 'services/workflow';
import getEnvValue from 'utils/getEnvValue';

export default function useWizardSteps(
  params: GetTaskStepWizardParams,
  defaultTabs: string[] = []
): Partial<TaskStepHomeResponse>[] | undefined {
  
  const canUseWorkflow = getEnvValue('USE_WORFLOW_ENGINE');

  const query = useQuery(
    ['getTaskStepWizard', params],
    () => getTaskStepWizard(params).then((res) => res.list || []),
    {
      enabled: canUseWorkflow,
      cacheTime:12000
    }
  );

  const { getComponentConfiguration } = useDisplayFrameworkContext();

  if (canUseWorkflow) {
    return query?.data;
  }

  return defaultTabs.reduce((result, tab, index) => {
    const config = getComponentConfiguration(tab);

    if (config?.flaghide !== true) {
      result.push({
        funcode: tab,
        steplabel: config ? config.comlabel : `##${tab}`,
        steporder: index,
      });
    }

    return result;
  }, [] as Partial<TaskStepHomeResponse>[]);
}
